module.exports = __webpack_public_path__ + "img/life-insurance-compare.0178e9f.webp";